import {Konfigurasjon} from "felles/infrastruktur/Konfigurasjon";
import {IComponentOptions, IController, IModule, IOnChangesObject} from "angular";
import {l} from "types/typescriptdefinisjoner_lederplan";
import {Strenger} from "felles/tjenester/Strenger";
import {ChangesFilter, dersomChangesInneholder} from "../../../felles/stoettefunk/angularHjelpemetoder";
import {gettextCatalog} from "angular-gettext";
import {regNavn} from "../../../felles/tjenester/tredjepartsTjenestenavn";
import _ from "lodash";

const css = require('./avatar.scss');

/**
 * Viser avatar for bruker eller gruppemedlem.
 * Bruk: <wk-avatar bruker='brukerObj'></wk-avatar> eller <wk-avatar medlem='gruppeMedlemObj'></wk-avatar>
 *
 * Ett av følgene parameter kan angis:
 * @param {l.EnkelBrukerModell} bruker brukeren vi viser avatar for
 * @param {l.GruppeMedlemListeModell} medlem gruppe-medlemmet vi viser avatar for
 * @param {string} bildeurl full url til bildet som skal vises (direktivet vil legge til autentiseringstoken)
 * @param {string} navn navnet vi vil vise intialenen for (Kai Lilleby blir KL)
 */
export function registrerAvatarKomponent(angular: IModule) {
    angular
      .component('wkAvatar', avatarKomponentDef())
}

export function avatarKomponentDef(): IComponentOptions {
    return {
        bindings: {
            bruker: "<",
            medlem: "<",
            bildeurl: "<",
            navn: "<",
            skjulTooltip: "@",
            stil: "@"
        },
        controller: AvatarKontroller.forInjisering(),
        template: require('./avatar.html')
    };
}

export class AvatarKontroller implements IController {

    static forInjisering() {
        return [
            regNavn.gettext.gettextCatalog,
            Konfigurasjon.regNavn,
            Strenger.regNavn,
            AvatarKontroller
        ];
    }

    constructor(private gettextCatalog: gettextCatalog,
                private konfigurasjon: Konfigurasjon,
                private strenger: Strenger) {
    }

    bruker: l.EnkelBrukerModell; //settes via bindings/$onChanges
    medlem: l.GruppeMedlemListeModell; //settes via bindings/$onChanges
    bildeurl: string; //settes via bindings/$onChanges
    navn: string; //settes via bindings/$onChanges

    skjulTooltip: string; //settes via bindings
    stil: 'mini' | 'liten' | 'stor' | 'xstor'; //settes via bindings

    url: string;
    initialer: string;
    ikon = "ion-ios-person";
    tilgangsstatus = '';

    $onChanges(changes: IOnChangesObject): void {
        dersomChangesInneholder(changes, 'bruker', bruker => this.kalkulerAvatarUrlForBruker(bruker), ChangesFilter.inkluderEndringTilNull);
        dersomChangesInneholder(changes, 'medlem', medlem => this.kalkulerAvatarUrlForMedlem(medlem), ChangesFilter.inkluderEndringTilNull);
        dersomChangesInneholder(changes, 'bildeurl', url => this.url = url, ChangesFilter.inkluderEndringTilNull);
        dersomChangesInneholder(changes, 'navn', navn => this.initialer = this.strenger.initialer(navn), ChangesFilter.inkluderEndringTilNull);
    }

    private kalkulerAvatarUrlForMedlem(medlem: l.GruppeMedlemListeModell) {
        if (_.isNil(medlem)) {
            this.nullstill();
            return;
        }
        this.medlem = medlem;
        this.initialer = this.medlem.navn ? this.strenger.initialer(this.medlem.navn) : null;
        this.url = this.medlem.avatarId ? `/api/medlem/${this.medlem.id}/avatar/${this.medlem.avatarId}.jpg` : null;
        this.tilgangsstatus = this.medlem.harTilgang ? '' : this.gettextCatalog.getString('(tilgang stengt)');
    }

    private kalkulerAvatarUrlForBruker(bruker: l.EnkelBrukerModell) {
        if (_.isNil(bruker)) {
            this.nullstill();
            return;
        }
        this.bruker = bruker;
        this.initialer = this.bruker.navn ? this.strenger.initialer(this.bruker.navn) : null;
        this.url = this.bruker.avatarId ? `/api/bruker/${this.bruker.id}/avatar/${this.bruker.avatarId}.jpg` : null;
    }

    private nullstill(){
        this.url = null;
        this.initialer = '';
        this.tilgangsstatus = '';
    }
}

